export default [
  {
    title: 'Discover',
    icon: { icon: 'mdi-compass-outline' },
    useLogo: true,
    to: '/discover',
  },
  {
    title: 'Bookings',
    icon: { icon: 'mdi-calendar-check-outline' },
    to: '/admin/bookings',
  },
  {
    title: 'Fans',
    icon: { icon: 'mdi-account-heart-outline' },
    to: '/admin/fans',
  },
  {
    title: 'Account',
    icon: { icon: 'mdi-storefront-outline' },
    to: '/admin/profile',
  },
]
